<template>
  <div class="i-header" v-if="userInfo">
    <van-nav-bar fixed placeholder @click-right="toggle">
      <template #right>
        <div class="i-header__nav-content">
          <div>
            {{ userInfo.name }}
            <span
              v-if="power('1-6')"
              @click.stop="showActionToggle"
              :style="{
                color: userInfo.online_state === '1' ? '#82d01a' : '#fd4f50',
              }"
            >
              <i class="online-state">{{
                userInfo.online_state === "1" ? "在岗" : "离岗"
              }}</i></span
            >
          </div>

          <div style="color: #999">
            {{ userInfo.store_name || userInfo.department_name }}-{{
              userInfo.role_name
            }}
          </div>
        </div>
      </template>
      <template #left>
        <van-image
          width="150px"
          height="30px"
          fit="contain"
          :src="require('@/assets/images/logo/logo3.png')"
        />
      </template>
    </van-nav-bar>

    <van-popup
      close-on-popstate
      v-model:show="show"
      round
      position="left"
      :style="{ width: '75%', height: '100%' }"
    >
      <div class="i-user">
        <van-image
          round
          width="10rem"
          height="10rem"
          fit="cover"
          :src="require('@/assets/images/logo/144.png')"
        />
        <div class="i-user__name">
          {{ userInfo.name }}
        </div>
        <div class="i-user__desc">
          {{ userInfo.department_name }} - {{ userInfo.role_name }}
        </div>
        <div
          class="i-user__desc"
          style="margin-top: 5px"
          v-if="power('1-6')"
          @click="showActionToggle"
        >
          当前状态：
          <span
            :style="{
              color: userInfo.online_state === '1' ? '#82d01a' : '#fd4f50',
            }"
          >
            <i class="online-state">
              {{ userInfo.online_state === "1" ? "在岗" : "离岗" }}</i
            ></span
          >
        </div>

        <van-cell-group class="i-user__group">
          <van-cell title="修改密码" is-link @click="showDialogToggle" />
        </van-cell-group>

        <div class="i-user__logout">
          <van-button
            round
            color="linear-gradient(to right, #0059ff, #86eafa)"
            block
            @click="logout"
          >
            退出登录
          </van-button>
        </div>
      </div>
    </van-popup>
    <!-- 修改密码 -->
    <van-dialog
      :show-cancel-button="!needResetPassword"
      v-model:show="showDialog"
      title="修改密码"
      :show-confirm-button="false"
    >
      <div class="update-password">
        <van-form @submit="passwordState.onSubmit">
          <van-cell-group inset>
            <div
              v-if="needResetPassword"
              style="
                color: red;
                font-size: 12px;
                padding-left: 15px;
                margin: 10px 0;
              "
            >
              * 您的密码过于简单，请修改密码
            </div>
            <van-field
              v-model="passwordState.password"
              type="password"
              name="password"
              label="旧密码"
              placeholder="请填写旧密码"
              :rules="[{ required: true, message: '请填写旧密码' }]"
            />
            <van-field
              v-model="passwordState.newPassword"
              type="password"
              name="newPassword"
              label="新密码"
              placeholder="请填写新密码"
              :rules="[{ required: true, message: '请填写新密码' }]"
            />
            <van-field
              v-model="passwordState.confirmPassword"
              type="password"
              name="confirmPassword"
              label="确认密码"
              placeholder="请填写确认密码"
              :rules="[
                { required: true, message: '请填写确认密码' },
                {
                  validator: validatorMessage,
                },
              ]"
            />
          </van-cell-group>
          <div style="margin: 16px">
            <van-button round block type="primary" native-type="submit">
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </van-dialog>
    <!-- 修改密码 end -->
    <!-- 修改状态 -->
    <van-action-sheet
      v-model:show="showAction"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="actionSelect"
    />
    <!-- 修改状态 end -->
  </div>
</template>
<script>
import { computed, reactive } from "vue";
import { useStore } from "@/store";
import { useToggle } from "@vueuse/core";
import { usePower, useHandleOpt } from "@/hooks";
import { userService } from "@/service";
import { Toast } from "vant";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "i-header",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const [show, toggle] = useToggle();
    const { power } = usePower();
    const userInfo = computed(() => store.state.userInfo);
    const { logout: _logout } = useHandleOpt();
    const [showDialog, showDialogToggle] = useToggle();

    const needResetPassword = computed(() => userInfo.value.conform_rule === 2);

    if (needResetPassword.value) {
      showDialogToggle(true);
    }

    const passwordState = reactive({
      password: "",
      newPassword: "",
      confirmPassword: "",
      async onSubmit(value) {
        try {
          passwordState.password = "";
          passwordState.newPassword = "";
          passwordState.confirmPassword = "";
          await userService.updatePassword(
            userInfo.value.id,
            value.newPassword,
            value.password
          );
          Toast.success("修改密码成功");
          showDialogToggle(false);
          await router.push({
            name: "Login",
          });
          store.commit("setUserInfo", null);
        } catch (error) {
          Toast.fail("修改失败");
        }
      },
    });
    const validatorMessage = () => {
      if (passwordState.newPassword !== passwordState.confirmPassword)
        return "两次密码不一致";
    };

    const [showAction, showActionToggle] = useToggle();
    const actions = [
      { name: "在岗", code: "1" },
      { name: "离岗", code: "2" },
    ];
    const actionSelect = async (action) => {
      try {
        await userService.updateUser(userInfo.value.id, action.code);
        Toast.success("切换状态成功！");
        store.commit("setUserInfo", {
          ...userInfo.value,
          online_state: action.code,
        });
      } catch (error) {
        Toast.fail("切换状态失败！");
      }
    };

    if (route.query.handle_opt === "on_duty") {
      actionSelect({
        code: "1",
      });
    }
    if (route.query.handle_opt === "leave_duty") {
      actionSelect({
        code: "2",
      });
    }

    if (route.query.handle_opt === "exit_user") {
      _logout(userInfo.value.id).then(() => {
        router.push({
          name: "Login",
          replace: true,
        });
      });
      return;
    }

    const logout = async () => {
      await _logout(userInfo.value.id);
      await router.push({
        name: "Login",
      });
    };
    return {
      show,
      toggle,
      power,
      logout,
      Toast,
      userInfo,
      needResetPassword,
      showDialog,
      passwordState,
      showDialogToggle,
      validatorMessage,
      showAction,
      showActionToggle,
      actions,
      actionSelect,
    };
  },
};
</script>

<style lang="less" scoped>
.online-state {
  font-size: 12px;
  font-style: normal;
}
.i-header__nav-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}
.i-user {
  padding-top: 40px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__name {
    font-size: 16px;
    color: #333;
    margin: 10px 0;
  }
  &__desc {
    font-size: 12px;
    color: #666;
  }
  &__group {
    width: 100%;
    margin-top: 30px;
  }
  &__logout {
    width: 100%;
    padding: 20px;
    margin-top: auto;
  }
}
</style>
